import { createElement } from "rax";
import * as Dinamic from "@ali/dinamic";
import { View, bindGestureEvent } from "@ali/dinamic-views-icbu-fork";
import { checkFavorite, addFavorite, removeFavorite } from './service';
import { getService } from '../../service'

// 商家 Follow  
class ALICompanyFollowButton extends View {
  _followed = false
  _favoriteId = null;

  componentWillMount() {
    this._preprocessingStyle();
  }

  _preprocessingStyle() {
    // 外部容器带有border, 取height值作为borderRadius
    // 内部小圆距离外部有 1px 的距离，此处单独处理一下
    const { height } = this.props;

    let size = Dinamic.unitParser(height);
    if (size == 'match_parent') {
      size = '100px';
    }
    this.setStyles({
      borderRadius: size,
      ...DefaultStyle
    }, 'btn');

    this.setStyles({
      backgroundColor: '#FFEDE0',
      color: '#FF6600',
    }, 'followed');

    this.setStyles({
      backgroundColor: '#FF6600',
      color: '#FFFFFF',
    }, 'unfollowed');
  }

  componentDidMount() {
    // 绑定手势
    bindGestureEvent(this.$btn, {
      tap: () => {
        this.toggleCheck();
      }
    });

    // 查询关注态
    checkFavorite(this.data.companyId).then(result => {
      if (result && result.isFavorite) {
        this._followed = true;
        this._favoriteId = result.fid;
        this.forceUpdate();
      }
    });
  }

  toggleCheck = () => {
    if (this._followed) {
      // 取关
      removeFavorite(this._favoriteId).then(result => {
        if (result.success) {
          this._followed = false;
          this._favoriteId = null;
          this.forceUpdate();
        }
      });
    } else {
      // 加关
      addFavorite(this.data.companyId).then(result => {
        if (result.success) {
          this._followed = true;
          this._favoriteId = result.fid;
          this.forceUpdate();
        }
      });
    }
  };

  data(propValue) {
    if (propValue) {
      this.data = propValue;
    }
  }

  renderView() {
    const followed = this._followed;
    const i18n = getService('i18n') || {};
    return (
      <span
        style={{
          ...this.getStyles('btn'),
          ...this.getStyles(followed ? 'followed' : 'unfollowed')
        }}
        ref={$btn => this.$btn = $btn}>
        {followed ? i18n['feed_detail_following'] || 'Following' : i18n['feeds_follow'] || 'Follow'}
      </span>
    );
  }

}

const DefaultStyle = {
  display: 'flex',
  width: '100%',
  textAlign: 'center',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  'min-height': '25px',     // Follow 组件最少 25 高度，避免有些情况撑不开
  'padding-left': '12px',
  'padding-right': '12px',
  'white-space': 'nowrap',
  'text-overflow': 'ellipsis',
};

ALICompanyFollowButton.defaultProps = {
  data: {}
};

Dinamic.registerView("ALICompanyFollowButton", ALICompanyFollowButton);

export default ALICompanyFollowButton;